// Icon.tsx
import React, { useRef, useMemo } from "react"
import { Text, TextStyle, StyleProp } from "~/ui/primitives"
import FontMap from "./FontMap"

const fontReference = "iconfont"

export interface IconProps {
  name?: string
  size?: number
  color?: string
  style?: StyleProp<TextStyle>
}

/**
 * Icon component (hooks + TypeScript version)
 */
export const Icon: React.FC<IconProps> = ({
  name = "",
  size = 15,
  color = "#303943",
  style = {},
  ...props
}) => {
  const textRef = useRef<Text>(null)

  // 计算字形
  const glyph = useMemo(() => FontMap(name), [name])

  const styleDefaults: TextStyle = {
    fontFamily: fontReference,
    fontSize: size,
    fontWeight: "normal",
    fontStyle: "normal",
    color,
  }

  return (
    <Text ref={textRef} style={[styleDefaults, style]} {...props}>
      {glyph}
    </Text>
  )
}

export default Icon
